import React, { Component } from 'react';
import { compose } from '../../reactApolloCompat';
import { withRouter } from '../../utils/withRouter';
import withStyles from '@mui/styles/withStyles';
import { withErrorBoundary } from '@sentry/react';
import DataFormView from '../../components/DataFormView';
import StockDetail from './StockItemView';
import { PAGE_STOCK } from '../../utils/strings';
import ErrorFallback from '../../components/ErrorFallback';
import GatedComponent from '../../components/GatedComponent';

class StockItem extends Component {
    render() {
        const { match } = this.props;
        return (
            <GatedComponent canEditCode={'CMS_ACCESS_SilverShop\\Admin\\ProductCatalogAdmin'}>
                {isEnabled => (
                    <DataFormView
                        tabs={[StockDetail]}
                        createNew={parseInt(match.params.id) === 0}
                        createNewFunc={() => {
                            return {
                                ID: null,
                                InternalItemID: null
                            };
                        }}
                        objectType="CMProduct"
                        itemId={match.params.id}
                        name="CMProduct"
                        //validation={validation}
                        context={this}
                        onCreated={e => this.onCreateNew(e)}
                        readOnly={!isEnabled}
                    />)}
            </GatedComponent>
        );
    }

    onCreateNew(obj) {
        const { history } = this.props;
        history.push(PAGE_STOCK + obj.ID);
    }
}

export default withErrorBoundary(compose(withRouter, withStyles({}))(StockItem), { fallback: ErrorFallback });
